<template>
  <div class="modifier-label">
    <span :class="{ selected: isSelected }">{{ modifier.displayName }}</span>
    <span v-if="displayCalories" class="modifier-label__calories">{{ modifier.calories }} {{ caloriesLabel }}</span>
  </div>
</template>

<script>
export default {
  name: "ModifierLabel",
  props: {
    modifier: Object,
    isSelected: Boolean
  },
  computed: {
    displayCalories() {
      return this.modifier.calories != null && this.modifier.calories !== "";
    },
    caloriesLabel() {
      return this.modifier.caloriesLabel || "cal";
    }
  }
};
</script>

<style lang="scss" scoped>
.modifier-label {
  display: flex;
  flex-direction: column;
  line-height: 150%;

  &__calories {
    font-size: 14px;
    color: #656565;
  }
}

.selected {
  font-weight: 900;
}
</style>
